import moon from '../../src/assets/images/moon.png';
import rockets from '../../src/assets/images/rockets.png';
import Title from 'antd/es/typography/Title';

export function LoginPage() {
    return (
        <>
            <div
                style={{
                    backgroundColor: "#323170",
                    clipPath: "ellipse(72% 55% at 34% 76%)",
                }}
                className="w-full h-full  absolute bottom-0 left-0"
            ></div><div
                style={{
                    backgroundColor: "#3a3985",
                    clipPath: "ellipse(72% 55% at 31% 93%)",
                }}
                className="w-full h-full absolute bottom-0 left-0"
            ></div><div className="w-full h-3/4 px-16 flex absolute  justify-end flex-col">
                <div className='flex'>

                    <img
                        src={rockets}
                        alt=""
                        width={140}
                        height={140}
                        style={{
                            position: "absolute",
                            top: 60,
                            left: 35,
                        }}
                    ></img>
                    <img
                        src={moon}
                        className=" p-3"
                        alt=""
                        width={140}
                        height={140}
                        style={{ position: "absolute", top: 45, right: 45 }}
                    ></img>
                </div> 
                <Title className="capitalize title-login">
                    Integrate All your
                    <br /> solutions together
                </Title>
                <Title
                    level={4}
                    className="capitalize m-0"
                    style={{ color: "#b5b5c3" }}
                >
                    More than 400+ new membersrs
                </Title>

            </div></>
    )




}